<template>
  <div id="RentalActivityReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
       <template v-if="cantAccessPage === true">
          <div class="page-name">
            <div class="page-title">Rental Activity With Rates (Sys Parameter)</div>
            <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
          </div>
          <div class="container-fluid">
            <div class="admin-page-content contact-list">
               <data-table-filter-config :moduleName="'rentalActivityWithRatesReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
               <div class="data-table bg-white overflow-hidden">
                  <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                  <section class="bg-white data-table">
                      <custom-pagination
                          :page-changed="onPageChange"
                          :per-page-changed="onPerPageChange" :moduleName="'rentalActivityWithRatesReport'" :position="'top'">
                      </custom-pagination>

                      <vue-good-table
                          ref="rentalActivityWithRatesReportTable"
                          mode="remote"
                          title="Rental Activity With Rates"
                          @on-page-change="onPageChange"
                          @on-sort-change="onSortChange"
                          @on-column-filter="onColumnFilter"
                          @on-per-page-change="onPerPageChange"
                          :totalRows="totalRecords"
                          :columns="userColumns"
                          :rows="rows"
                          :isLoading=false
                          :paginationOptions="{
                              enabled: false,
                              position: 'both',
                              perPage: perPage,
                              dropdownAllowAll: false,
                              setCurrentPage:listCurrentPage,
                              perPageDropdown:dropDownPerPage,
                          }"
                          :search-options="{
                          enabled: false,
                          }"
                          :sort-options="{
                          enabled: true,
                          }">
                      </vue-good-table>
                      <custom-pagination
                          :page-changed="onPageChange"
                          :per-page-changed="onPerPageChange">
                      </custom-pagination>
                  </section>
               </div>

            </div>
          </div>
       </template>
       <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
  name: "RentalActivityReport",
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
      cantAccessPage:"",
      loading: false,
      pageTitle:'Rental Activity With Rates',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
        {
            label: "Customer Name",
            field: "customer_name",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
        },
        {
            label: "Customer Number",
            field: "customer_code",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
        },
        {
            label: "Attachment",
            field: "attachment",
            fpFieldType:"text",
            filterable: false,
            hidden:false,
            sortable:false
        },
        {
            label: "Unit Number",
            field: "unit_no",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            width: '90px',

        },
        {
            label: "Date Out",
            field: "pickup_datetime",
            filterable: true,
            fpFieldType:"custom_date",
            hidden:false,
        },
        {
            label: "Date In",
            field: "dropoff_datetime",
            filterable: true,
            fpFieldType:"custom_date",
            hidden:false,
        },
        {
            label: "RA Number",
            field: "agreement_number",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Days Utilized in Period",
            field: "days_utilized",
            fpFieldType:"text",
            filterable: false,
            hidden:false,
            sortable:false
        },
        {
            label: "Days Utilized Total",
            field: "days_utilized_total",
            fpFieldType:"text",
            filterable: false,
            hidden:false,
            sortable:false
        },
        {
            label: "Prov/State Code",
            field: "state_code",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            // sortable:false
        },
        {
            label: "Out Reading",
            field: "reading_out",
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: "In Reading",
            field: "reading_in",
            fpFieldType:"integer",
            type : 'number',
            filterable: false,
            hidden:false,
            sortable:false
        },
        {
            label: "Contract Miles",
            field: "miles",
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false

        },
        {
            label: "Metric Type",
            field: "uom",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "VIN #",
            field: "vin",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            width: '90px',
        },
        {
            label: "Facility Responsible",
            field: "assigned_facility",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            width: '90px',
        },
        {
            label: "Responsible Fac Desc",
            field: "assigned_facility_desc",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            width: '90px',
        },
        {
            label: "Facility Out",
            field: "loc_out",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            width: '90px',
        },
        {
            label: "Out Fac Desc",
            field: "loc_out_desc",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            width: '90px',
        },
        {
            label: "Facility Domicile",
            field: "location",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            width: '90px',
        },
        {
            label: "Domicile Fac Desc",
            field: "location_desc",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            width: '90px',
        },
        {
            label: "Year",
            field: "year",
            // type: "number",
            filterable: true,
            fpFieldType:"text",
            hidden:false,

        },
        {
            label: "Manufacturer Code",
            field: "manufacturer",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Model Code",
            field: "model",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Equipment Type",
            field: "asset_type",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
        },
        {
            label: "Equipment Type Description",
            field: "asset_type_desc",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Customer PO Number",
            field: "po",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Sales Rep",
            field: "sale_rep",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Salesname",
            field: "sales_name",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Replaced Unit",
            field: "replaced_unit",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            sortable:false
        },
        {
            label: "Replaced Reason",
            field: "replaced_reason",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            sortable:false
        },
        {
            label: "Customer Class Code",
            field: "customer_class",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            // sortable:false
        },
        {
            label: "Planned In Date",
            field: "planned_in_date",
            filterable: true,
            fpFieldType:"custom_date",
            hidden:false,
        },
        {
            label: "Pool",
            field: "pool",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
        },
        {
            label: "Contract Type",
            field: "contract_type",
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            // sortable:false
        },
         {
            label: 'Transmission Type',
            field: 'trans_type',
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            sortable:false
        },
        {
            label: 'Current Metric 1 Reading',
            field: 'reading1',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Current Metric 1 UOM',
            field: 'uom1',
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            sortable:false
        },
        {
            label: 'Current Metric 1 Date',
            field: 'reading_date1',
            filterable: false,
            fpFieldType:"custom_date",
            hidden:false,
            sortable:false
        },
        {
            label: 'Current Metric 2 Reading',
            field: 'reading2',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Current Metric 2 UOM',
            field: 'uom2',
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            sortable:false
        },
        {
            label: 'Current Metric 2 Date',
            field: 'reading_date2',
            filterable: false,
            fpFieldType:"custom_date",
            hidden:false,
            sortable:false
        },
        {
            label: 'Current Metric 3 Reading',
            field: 'reading3',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Current Metric 3 UOM',
            field: 'uom3',
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            sortable:false
        },
        {
            label: 'Current Metric 3 Date',
            field: 'reading_date3',
            filterable: false,
            fpFieldType:"custom_date",
            hidden:false,
            sortable:false
        },
        {
            label: 'Fixed Rate 1',
            field: 'fixed1',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Fixed Rate 2',
            field: 'fixed2',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Fixed Rate 3',
            field: 'fixed3',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Fixed Rate 4',
            field: 'fixed4',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Fixed Rate 5',
            field: 'fixed5',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Fixed Rate 6',
            field: 'fixed6',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Fixed Rate 7',
            field: 'fixed7',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Variable Rate 1',
            field: 'variable1',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Variable Rate 2',
            field: 'variable2',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Variable Rate 3',
            field: 'variable3',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Variable Rate 4',
            field: 'variable4',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Variable Rate 5',
            field: 'variable5',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Variable Rate 6',
            field: 'variable6',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Variable Rate 7',
            field: 'variable7',
            filterable: false,
            fpFieldType:"integer",
            type : 'number',
            hidden:false,
            sortable:false
        },
        {
            label: 'Start Date',
            field: 'start_date',
            filterable: false,
            fpFieldType:"text",
            hidden:true,
            sortable:false
        },
        {
            label: 'End Date',
            field: 'end_date',
            filterable: false,
            fpFieldType:"text",
            hidden:true,
            sortable:false
        },
      ],
      action : 'list',
      batchProcess:0,
      batchNum:"",

  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'rental_activity_with_rates_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.rentalActivityReportTable.unselectAllInternal();
    },
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){


      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      $.ajax({
        url: process.env.ROOT_API + "/rental-activity-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          from:'rates',
          action : self.action

        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {
            if ( self.action == "export" ||  self.action == "export_queue") {
                  if ( data.code == "201" ) {
                      alert(data.message);
                  } else {
                      if ( self.action == "export" ) {
                          self.excel = data.content.web;
                          var save = document.createElement("a");
                          save.href = self.excel;
                          save.download = data.content.web;
                          save.target = "_blank";

                          document.body.appendChild(save);
                          save.click();
                          document.body.removeChild(save);

                      } else {

                          self.batchProcess = 1;
                          self.batchNum = data.content;
                      }
                  }
                  self.action = "list";
                  // self.loadList();

            } else {
               if (data.content.row != undefined) {
                  self.rows = data.content.row;
                }

                self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'reservation-list-booking')
        }
      });

    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/RentalActivityWithRatesReport.vue